<template>
     <div>
        <h2>{{ step.title }}</h2>
        <p>If you need to leave this page, your answers will be saved for 24 hours.</p>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>

        <InputRadioGroupVar
            name="currently_in_education"
            :required="checkIsRequired('currently_in_education')"
            :error="formRef.errors.get('currently_in_education')"
            v-model="formRef.currently_in_education"
            :options="getField('currently_in_education')['options']"
            @input="formRef.errors.clear('currently_in_education')"
        >
            <template v-slot:question>
                {{ getField("currently_in_education").question }}
            </template>
        </InputRadioGroupVar>

        <InputNumber
            v-if="formRef.currently_in_education == 'yes'"
            name="average_education_hours"
            :required="checkIsRequired('average_education_hours')"
            :error="formRef.errors.get('average_education_hours')"
            v-model="formRef.average_education_hours"
        >
            <template v-slot:question>
                {{ getField("average_education_hours").question }}
            </template>
            <template v-slot:description>
                {{ getField("average_education_hours").description }}
            </template>
        </InputNumber>

        <InputYearsMonths
            v-if="formRef.currently_in_education == 'no'"
            name="since_last_education_months"
            :required="checkIsRequired('since_last_education_years')"
            :error="
                formRef.errors.get('since_last_education_years') ||  formRef.errors.get('since_last_education_months')
            "
            v-model:years="formRef.since_last_education_years"
            v-model:months="formRef.since_last_education_months"
        >
            <template v-slot:question>
                {{ getField("since_last_education_months").question }}
            </template>
            <template v-slot:description>
                {{ getField("since_last_education_months").description }}
            </template>
        </InputYearsMonths>
    </div>
</template>

<script setup>
import InputNumber from "../../../Form/InputNumber";
import InputRadioGroup from "../../../Form/InputRadioGroup";
import InputYearsMonths from "../../../Form/InputYearsMonths";
import Form from "../../../../Form";
import { isRequired } from "./formHelper.js";
import { ref, shallowRef, markRaw } from "vue";

const props = defineProps({
    step: Object,
    fields: Object,
    formData: Object
})

const InputRadioGroupVar = shallowRef(InputRadioGroup)

let formRef = markRaw(ref(new Form({
    currently_in_education: null,
    average_education_hours: null,
    since_last_education_months: null,
    since_last_education_years: null,
}, props.formData)))

const getField = (fieldName) => {
    return props.fields[fieldName];
}

const checkIsRequired = (fieldName) => {
    var fieldData = getField(fieldName);
    return isRequired(fieldData, formRef.value);
}

defineExpose({
  formRef
})
</script>